<template>
  <div id="app">
    <keep-alive include="MonitorView,ScreenControlView">
      <router-view/>
    </keep-alive>
      <!-- 底部导航：仅在非登录页显示 -->
      <BottomNav v-if="$route.path === '/mine'  || $route.path === '/screenControl'|| $route.path === '/monitor' || $route.path === '/inspection' "/>
  </div>
</template>

<script>
// 导入底部导航组件
import BottomNav from './components/BottomNav.vue'

export default {
    name: 'App',
    components: {
        BottomNav
    }
}

</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    padding: 0;
}
</style>
